
export interface SnackbarStore {
  open: boolean,
  message: string,
}

export enum SnackbarActions {
  OPEN_SNACKBAR = 'OPEN_SNACKBAR',
  CLOSE_SNACKBAR = 'CLOSE_SNACKBAR',
}

const createDefaultState = (): SnackbarStore => ({
  open: false,
  message: '',
})


const createSnackbarStoreReducer = () => (state: SnackbarStore = createDefaultState(), action: any): SnackbarStore => {
  switch (action.type) {
    case SnackbarActions.OPEN_SNACKBAR: {
      if (!action.payload) {
        return state
      }
      const { message } = action.payload
      return {
        ...state,
        open: true,
        message,
      }
    }
    case SnackbarActions.CLOSE_SNACKBAR: {
      return {
        ...state,
        open: false,
      }
    }
    default: {
      return state
    }
  }
}


export default createSnackbarStoreReducer
